const fromAssignmentUnitsV2 = (aus) => aus.map((au, index) => ({
  Id: au.id,
  DisplayName: au.displayName,
  IsDefault: false,
  IsHidden: au.isArchived
}));
export {
  fromAssignmentUnitsV2
};
//# sourceMappingURL=AssignmentUnitUtils.js.map
